import { Card } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import Portal from '../../../components/Portal';
import UserTable from '../components/UserTable';

const UserList = () => {
  const {
    state: { pageSize }
  } = useContext(AppContext);
  return (
    <Card className="full-height-card card-body-padding">
      <Portal portalId="header-left-content">
        <span className="portal-header">Users</span>
      </Portal>
      {pageSize && <UserTable />}
    </Card>
  );
};

export default UserList;
